import React, { useState } from 'react';
import { message } from 'antd';
import { deleteToken } from 'firebase/messaging';
// import { messaging } from '../firebase';
import { generateFcmToken, requestFirebaseNotificationPermission } from '../../utils/pushNotification';
import { messaging } from '../../firebase';
import EditorSwitch from '../editorSwitch';
import useSkipFirstEffect from '../../utils/hook/useSkipFirstEffect';
import { sentFirebaseToken } from '../../utils/utils';
import { useDispatch,useSelector } from "react-redux";
import { setFcmToken } from '../../app/slice/chatSlice';

const NotificationToggle = () => {
    const permission = Notification?.permission;
    console.log(permission)
  const [enabled, setEnabled] = useState(() => {
    return permission === 'granted';
  });
  const [isLoading, setIsloading] = useState(false);
    const dispatch = useDispatch();
    const fcmToken = useSelector((state)=>state.chat.fcmToken)

  const onNotificationStatus=(val)=>{
  setIsloading(true)
      if (val) {
        if( permission !== 'granted'  ){
            requestFirebaseNotificationPermission().then((token) => {
              if (token) {
                  sentFirebaseToken(token);
                  setIsloading(false)
                  dispatch(setFcmToken(token))
                  message.success('Notifications enabled');
              } else {
                message.error('Failed to enable notifications');
              }
              console.log(token, 'inside token false')
                setIsloading(false)
            });
        }else{
            console.log(permission, 'permission grane')
          if( !!fcmToken){
            message.success('Notifications enabled');
             setIsloading(false);
             return;
          }
          console.log(fcmToken, 'fcmToken flase')
          generateFcmToken().then((token)=>{
            sentFirebaseToken(token);
            dispatch(setFcmToken(token));
             message.success('Notifications val');
          }).catch((err)=>{
            console.log(err)
          }).finally(()=>{
                 setIsloading(false)
          })
          // generate token
        }
    } else {
      // Unsubscribe or delete FCM token
      deleteToken(messaging)
        .then(() => {
             dispatch(setFcmToken(''));
          message.info('Notifications disabled');
        })
        .catch((err) => {
          message.error('Failed to disable notifications');
        }).finally(()=>{
              setIsloading(false)
        })
    }
  }

  const onChange=(val)=>{
    console.log('onchange', val)
    setEnabled(val)
    onNotificationStatus(val)
  }

  return (
    <div className='dark:text-gray-200 flex justify-between items-center mb-4 '>
      <div style={{ marginRight: 8 }}>Push Notifications :</div>
    <EditorSwitch  state1={'ON'} state2={'OFF'} isLoading={isLoading} initialState={permission== 'granted' && !!fcmToken} handleSwitchChange={onChange} />

    </div>
  );
};

export default  React.memo(NotificationToggle);
